import { gql } from "@apollo/client"

const zipRatingQuery = gql`
  query ZipRating($zip: String!) {
    zipRatings(where: { zip: $zip }) {
      id
      income_rating
      income_score
      bachelor_degree_rate
      business_rating
      business_score
      college_degree_rate
      edu_rating
      edu_score
      educated_rate
      employment_mean
      employment_rate
      employment_rating
      graduate_degree_rate
      high_school_diploma_rate
      hotness_rank
      hotness_score
      median_days_on_market
      median_days_on_market_mm
      median_days_on_market_yy
      median_income
      median_dom_vs_us
      median_listing_price
      median_listing_price_vs_us
      median_listing_price_mm
      median_listing_price_yy
      overall_rating
      overall_score
      poverty_rate
      poverty_rating
      poverty_score
      tax_rate
      total_employed
      total_population
      zip
    }
  }
`

export default zipRatingQuery
